import styles from "./Components/styles.module.css";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import KeyboardDoubleArrowRightOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import KeyboardDoubleArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftOutlined";
import { IconButton, MenuList } from "@mui/material";
import clsx from "clsx";
import VirtualList from "../../Tools/VirtualList/VirtualList";
import React, { useContext, useEffect, useRef, useState } from "react";
import { formEdit } from "../../Tools/Tools";
import { SmetaModalsButtonsContext } from "../../Tools/modalManager";
import { Prefixes } from "../../Tools/ProjectX";

interface ListProps {
  props: {
    sourName: string;
    destName: string;
    sourList: string | any;
    destList: string | any;
    RequestID?: string;
    func?: any;
    from?: string;
    Name?: string;
    record?: any;
    Module?: Prefixes;
    addInfo?: any;
    setValue?: (value: any) => void;
    setInputValue?: (value: string) => void;
    onEdit?: (data: any) => void;
  };
}

interface Item {
  text: string;
  id: string;
}

export default function DialogSelectFromList({ props }: ListProps) {
  const { destName, sourList, destList, sourName, RequestID: requestId, func, from } = props;

  const sourListData = useRef<Array<Item>>([]);
  const destListData = useRef<Array<Item>>([]);
  const sourSelected = useRef<Item>();
  const destSelected = useRef<Item>();

  const [sour, setSour] = useState<Array<Item>>([]);
  const [dest, setDest] = useState<Array<Item>>([]);
  const [sSelected, setSSelected] = useState<Item>();
  const [dSelected, setDSelected] = useState<Item>();

  const setButtons = useContext(SmetaModalsButtonsContext);

  useEffect(() => {
    setButtons?.({
      1: { label: "Выбрать", onClick: onSelect },
    });
  }, [setButtons, destListData.current]);

  const getData = (list: string | any) => {
    if (!list) return [];
    if (typeof list !== "string") {
      return Object.values(list).map((item: any) => {
        return { text: item.text, id: item.id };
      });
    }

    return list
      .replaceAll('"', "")
      .split(",")
      .map((item, index) => {
        return {
          text: item,
          id: `${index}`,
        };
      });
  };

  useEffect(() => {
    if (sourList) {
      sourListData.current = getData(sourList);
      destListData.current = getData(destList);

      if (sourListData.current.length) {
        sourSelected.current = sourListData.current[0];
      }

      updateLists();
    }
  }, [sourList]);

  const updateLists = () => {
    setDest([...destListData.current]);
    setSour([...sourListData.current]);
    setSSelected(sourSelected.current);
    setDSelected(destSelected.current);
  };

  const onClickMoveSour = () => {
    let index = 0;
    sourListData.current = sourListData.current.filter((item, id) => {
      if (item.text === sourSelected.current?.text) {
        destListData.current.push(sourSelected.current);
        index = id;
        return false;
      }
      return true;
    });

    if (sourListData.current.length) {
      sourSelected.current = index > 0 ? sourListData.current[index - 1] : sourListData.current[0];
    }

    destListData.current = [...destListData.current];
    updateLists();
  };

  const onClickMoveDest = () => {
    let index = 0;
    destListData.current = destListData.current.filter((item, id) => {
      if (item.text === destSelected.current?.text) {
        sourListData.current.push(destSelected.current);
        index = id;
        return false;
      }
      return true;
    });

    if (destListData.current.length) {
      destSelected.current = index > 0 ? destListData.current[index - 1] : destListData.current[0];
    }

    sourListData.current = [...sourListData.current];
    updateLists();
  };

  const onClickMoveDestAll = () => {
    const oldLength = sourListData.current.length;
    sourListData.current = [...sourListData.current, ...destListData.current];
    destListData.current = [];
    if (sourListData.current.length && oldLength === 0) sourSelected.current = sourListData.current[0];
    updateLists();
  };

  const onClickMoveSourAll = () => {
    const oldLength = destListData.current.length;
    destListData.current = [...destListData.current, ...sourListData.current];
    sourListData.current = [];
    if (destListData.current.length && oldLength === 0) destSelected.current = destListData.current[0];
    updateLists();
  };

  const onSelect = async () => {
    const cellText = destListData.current
      .map((item) => {
        return `${item.text}`;
      })
      .join(", ");

    if (requestId)
      await formEdit(
        "1",
        func,
        {
          $SourList: sourListData.current.map(({ text, id }) => ({ text, id })),
          $DestList: destListData.current.map(({ text, id }) => ({ text, id })),
          Name: "Selection",
          Value: cellText,
        },
        requestId,
        from,
      );
    props.onEdit?.({
      value: cellText,
      name: props.Name,
      record: props.record,
      textchanged: "0",
      setValue: props.setValue,
      setInputValue: props.setInputValue,
      type: props.Module,
      addInfo: props.addInfo,
    });
  };

  return (
    <div className={clsx(styles.mainDialogBlock)}>
      <div className={clsx(styles.fullDialogFlexContainer)}>
        <div className={clsx(styles.dialogSelectFromListListContainer)}>
          <div className={clsx(styles.dialogSelectFromListListLabel)}>{sourName}</div>
          <div className={clsx(styles.dialogSelectFromListList)}>
            <MenuList
              tabIndex="-1"
              style={{
                height: "calc(100% + 1px)",
                width: "100%",
                outline: "none",
              }}
            >
              <VirtualList
                items={sour}
                selected={sSelected}
                onClick={(data: { text: string; id: string }) => {
                  sourSelected.current = data;
                  setSSelected(sourSelected.current);
                }}
              />
            </MenuList>
          </div>
        </div>
        <div className={clsx(styles.dialogSelectFromListButtonsContainer)}>
          <IconButton onClick={onClickMoveSourAll}>
            <KeyboardDoubleArrowRightOutlinedIcon />
          </IconButton>
          <IconButton onClick={onClickMoveSour}>
            <KeyboardArrowRightOutlinedIcon />
          </IconButton>
          <IconButton onClick={onClickMoveDest}>
            <KeyboardArrowLeftOutlinedIcon />
          </IconButton>
          <IconButton onClick={onClickMoveDestAll}>
            <KeyboardDoubleArrowLeftOutlinedIcon />
          </IconButton>
        </div>
        <div className={clsx(styles.dialogSelectFromListListContainer)}>
          <div className={clsx(styles.dialogSelectFromListListLabel)}>{destName}</div>
          <div className={clsx(styles.dialogSelectFromListList)}>
            <MenuList
              tabIndex="-1"
              style={{
                height: "calc(100% + 1px)",
                width: "100%",
                outline: "none",
              }}
            >
              <VirtualList
                items={dest}
                selected={dSelected}
                onClick={(data: { text: string; id: string }) => {
                  destSelected.current = data;
                  setDSelected(destSelected.current);
                }}
              />
            </MenuList>
          </div>
        </div>
      </div>
    </div>
  );
}
